export default __webpack_public_path__ + "static/media/fitness_mfp1.b85edd39.jpg";